module.exports = "<section id=\"user-account-data\">\n    PS\n</section>";


//////////////////
// WEBPACK FOOTER
// ./src/app/sections/registration/paypal-cancel/paypal-cancel.html
// module id = 533
// module chunks = 0